/* OO(2026-10-10) トップの「COLOR（カラーで選ぶ）」と、見やすさの直し

   1) トップの「COLOR」を、いちばん上の大きな写真のすぐ下へ置く
   2) 色の丸を押すと、ページを移らずに下の12点がその色に入れ替わる
   3) トップの帯は、どれも隠さない
   4) メニューの並びを NEW → RANKING → ブランド… にする
   5) 中身が0件で隠してあるメニューの行ごと詰める
   6) 商品ページの「インスタの着用写真」の予備の置き場所（いまは使っていない）
   7) 「インスタの着用写真」の枠を、商品の説明のすぐ下へ上げる
   8) 「RANKING」の行き先を、直近30日の売れた順の一覧に向ける
   9) 着こなしの写真が1〜2枚のときは大きく出す
  10) 絞り込みの引き出しの「すべてクリア」「適用」を、いちばん下に貼り付ける
  11) レビューが0件のときは、レビューの枠ごと出さない
  12) 英語や変な訳の見出しを直し、値段のカンマも入れ直す
  13) 検索ページの見出しを「「○○」の検索結果」にする
  14) カートが空のときの「こちらもおすすめ」（中身なし）を隠す
  15) トップの商品の枠の形を整える（横スワイプのまま、帯ごとに1段か2段）
  16) 売り切れの商品を、帯のうしろへ回す
  17) トップの帯を BBIMP → NEW ARRIVAL → RANKING → COLOR → ALL ITEM の順に並べる
  18) 検索の打ち込み欄に薄く出る字を「商品名・ブランド名で検索」にする
  19) 一覧ページでも、売り切れをそのページの後ろへ回す
  20) 絞り込んだあと、中身が描き直されても上の直しが効くようにする
  21) 検索の候補に「417」とだけ出るのを隠す
  22) 一覧の並び替えから「関連性が最も高い」を外す */
(function () {
  'use strict';

  /* ----------------------------------------------------------------
     1) トップの入口を、いちばん上の写真のすぐ下へ置く
  ---------------------------------------------------------------- */
  function placeEntry() {
    var box = document.getElementById('oo-entry');
    if (!box || box.classList.contains('is-placed')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;

    var first = main.firstElementChild;
    while (first && (first === box || first.contains(box) || !first.classList.contains('shopify-section'))) {
      first = first.nextElementSibling;
    }
    if (!first || !first.parentNode) return;

    first.parentNode.insertBefore(box, first.nextElementSibling);
    box.classList.add('is-placed');
  }

  /* ----------------------------------------------------------------
     2) 色の入れ替え
        ※ 差し込みに createContextualFragment を使うのは、カードの中の
           <script>（サイズや値段のデータ）も動くようにするため
  ---------------------------------------------------------------- */
  var ooCache = {};

  function ajaxUrl(u) {
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'view=ajax';
  }

  function showSlides(html, colUrl) {
    var box = document.getElementById('oo-entry');
    if (!box) return;
    var wrap = box.querySelector('[data-oo-grid]');
    var slider = box.querySelector('[data-oo-slider]');
    var more = box.querySelector('[data-oo-more]');
    if (!wrap) return;

    wrap.innerHTML = '';
    if (!html || !html.replace(/\s+/g, '')) {
      wrap.innerHTML = '<div class="swiper-slide card-product-slider__slide oo-grid__msg">この色の商品は、いまありません。</div>';
    } else {
      wrap.appendChild(document.createRange().createContextualFragment(html));
    }
    wrap.querySelectorAll('product-card').forEach(function (card) {
      if (typeof card.init !== 'function') return;
      try {
        card.init();
      } catch (err) {
        /* 1枚うまくいかなくても、ほかの札は出ているので止めない */
      }
    });

    soldOutLast(wrap);

    if (more) more.setAttribute('href', colUrl);
    if (slider && slider.swiper) {
      try {
        slider.swiper.update();
        slider.swiper.slideTo(0, 0);
      } catch (err) {
        /* 並びの作り直しに失敗しても、商品は出ているので止めない */
      }
    }
    if (slider) fitRowsHeight(slider);
    // 入れ替えた札の値段にカンマが入っていないことがあるので、ここで直す（2026-10-10）
    fixWords();
    wrap.classList.remove('is-busy');
  }

  function loadColor(colUrl) {
    if (!colUrl) return;
    var box = document.getElementById('oo-entry');
    var wrap = box ? box.querySelector('[data-oo-grid]') : null;
    if (!wrap) return;
    wrap.classList.add('is-busy');

    if (ooCache[colUrl] !== undefined) {
      showSlides(ooCache[colUrl], colUrl);
      return;
    }
    var t0 = Date.now();
    window.fetch(ajaxUrl(colUrl), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        ooCache[colUrl] = txt;
        window.ooLastMs = Date.now() - t0;
        showSlides(txt, colUrl);
      })
      .catch(function () {
        wrap.classList.remove('is-busy');
        wrap.innerHTML = '<div class="swiper-slide card-product-slider__slide oo-grid__msg">うまく出せませんでした。もう一度お試しください。</div>';
      });
  }

  function initEntryColors() {
    var box = document.getElementById('oo-entry');
    if (!box || box.getAttribute('data-oo-ready')) return;
    box.setAttribute('data-oo-ready', '1');

    box.addEventListener('click', function (e) {
      var col = e.target.closest ? e.target.closest('[data-oo-color]') : null;
      if (!col) return;
      box.querySelectorAll('[data-oo-color]').forEach(function (b) {
        b.classList.toggle('is-on', b === col);
      });
      loadColor(col.getAttribute('data-oo-col'));
    });

    var def = box.getAttribute('data-oo-default');
    if (def) loadColor(def);
  }

  /* ----------------------------------------------------------------
     3) トップの帯を隠す仕組み（いまは何も隠していない）
  ---------------------------------------------------------------- */
  var DUP = [];

  function hideDupHomeSections() {
    if (!DUP.length) return;
    if (document.body.className.indexOf('template--index') < 0) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    Array.prototype.slice.call(main.children).forEach(function (sec) {
      if (sec.id === 'oo-entry' || sec.getAttribute('data-oo-dup')) return;
      var h = sec.querySelector('h1, h2, h3');
      if (!h) return;
      var t = (h.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
      if (DUP.indexOf(t) < 0) return;
      sec.style.display = 'none';
      sec.setAttribute('data-oo-dup', '1');
    });
  }

  /* ----------------------------------------------------------------
     4) メニューの並びを NEW → RANKING → ブランド… にする
  ---------------------------------------------------------------- */
  function headText(li) {
    var head = li.querySelector('a, button');
    if (!head) return '';
    return (head.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function moveRanking() {
    document.querySelectorAll('.primary-menu-panel > ul, ul.header__nav-items').forEach(function (list) {
      var items = Array.prototype.slice.call(list.children);
      var newItem = null;
      var rankItem = null;

      items.forEach(function (li) {
        if (!newItem && li.querySelector('[data-oo-new]')) newItem = li;
        if (!rankItem && headText(li) === 'RANKING') rankItem = li;
      });
      if (!rankItem) return;

      var target = newItem ? newItem.nextElementSibling : list.firstElementChild;
      if (target === rankItem) return;
      if (!newItem && list.firstElementChild === rankItem) return;
      list.insertBefore(rankItem, target);
    });
  }

  /* ----------------------------------------------------------------
     5) 中身が0件で隠してあるメニュー（いまは OUTLET SALE）の行ごと詰める
  ---------------------------------------------------------------- */
  function hideEmptyMenuItem() {
    document.querySelectorAll('a[href$="/collections/outlet-sale"]').forEach(function (a) {
      if (window.getComputedStyle(a).display !== 'none') return;
      var li = a.closest('li');
      if (li) li.style.display = 'none';
    });
  }

  /* ----------------------------------------------------------------
     6) 「インスタの着用写真」の予備の置き場所
  ---------------------------------------------------------------- */
  function placeStyling() {
    var box = document.getElementById('oo-styling');
    if (!box || box.classList.contains('is-placed')) return;
    var anchor = document.querySelector('.product-form, .product__info, .product__variant-picker');
    var sec = anchor ? anchor.closest('.shopify-section') : null;
    if (!sec || !sec.parentNode || sec.contains(box)) return;

    sec.parentNode.insertBefore(box, sec.nextElementSibling);
    box.classList.add('is-placed');
  }

  /* ----------------------------------------------------------------
     7) 「インスタの着用写真」の枠を、商品の説明のすぐ下へ上げる
  ---------------------------------------------------------------- */
  var LEEEP = [
    { en: 'INSTAGRAM', ja: 'インスタの着用写真' },
    { en: 'OLD ORDER STYLING', ja: 'OLD ORDER の着こなし' }
  ];

  function moveStylingSections() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var after = main.querySelector('.shopify-section.section-accordions')
      || main.querySelector('.shopify-section.main-product');
    if (!after || after.parentNode !== main) return;

    LEEEP.forEach(function (item) {
      var target = null;
      Array.prototype.slice.call(main.children).forEach(function (sec) {
        if (target) return;
        var h = sec.querySelector('h1, h2, h3');
        if (!h) return;
        if ((h.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase() !== item.en) return;
        target = sec;
        h.textContent = item.ja;
      });
      if (!target || target === after) return;
      after.parentNode.insertBefore(target, after.nextElementSibling);
      after = target;
    });
  }

  /* ----------------------------------------------------------------
     8) 「RANKING」の行き先を、直近30日の売れた順の一覧に向ける
  ---------------------------------------------------------------- */
  function fixRankingLink() {
    document.querySelectorAll('a[href$="/collections/ranking"]').forEach(function (a) {
      a.setAttribute('href', '/collections/ranking-sales-30d');
    });
  }

  /* ----------------------------------------------------------------
     14) カートが空のときの「こちらもおすすめ」（中身なし）を隠す
  ---------------------------------------------------------------- */
  function hideEmptyRecommend() {
    if (document.body.className.indexOf('template--cart') < 0) return;
    document.querySelectorAll('#MainContent .shopify-section').forEach(function (sec) {
      if (sec.getAttribute('data-oo-rec')) return;
      var h = sec.querySelector('h1, h2, h3');
      if (!h) return;
      var t = (h.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
      if (t !== 'こちらもおすすめ' && t !== 'YOU MAY ALSO LIKE') return;
      if (sec.querySelector('a[href*="/products/"]')) return;
      sec.style.display = 'none';
      sec.setAttribute('data-oo-rec', '1');
    });
  }

  /* ----------------------------------------------------------------
     9) 着こなしの写真が1〜2枚しかないとき、写真を大きくする
  ---------------------------------------------------------------- */
  function leeepFew() {
    document.querySelectorAll('.LeeepSearchFilterContainer').forEach(function (box) {
      var n = box.querySelectorAll('.LeeepPost').length;
      if (!n) return;
      box.classList.toggle('oo-leeep-few', n <= 2);
      box.classList.toggle('oo-leeep-2', n === 2);
    });
  }

  /* ----------------------------------------------------------------
     10) 絞り込みの引き出しの「すべてクリア」「適用」を、いちばん下に貼り付ける
  ---------------------------------------------------------------- */
  function stickyFacetButtons() {
    document.querySelectorAll('.drawer__content-facets').forEach(function (box) {
      if (box.querySelector('.oo-facet-foot')) return;
      var apply = box.querySelector('.drawer__row--buttons');
      var clear = box.querySelector('.facets__clear-button');
      var clearBox = clear ? clear.parentElement : null;
      if (clearBox === box) clearBox = clear;
      if (!apply && !clearBox) return;

      var foot = document.createElement('div');
      foot.className = 'oo-facet-foot';
      box.appendChild(foot);
      if (clearBox) foot.appendChild(clearBox);
      if (apply) foot.appendChild(apply);
    });
  }

  /* ----------------------------------------------------------------
     11) レビューが0件のときは、レビューの枠ごと出さない
  ---------------------------------------------------------------- */
  function hideEmptyReviewSection() {
    document.querySelectorAll('#MainContent .shopify-section').forEach(function (sec) {
      if (sec.getAttribute('data-oo-rev')) return;
      var t = sec.innerText || '';
      if (t.indexOf('まだレビューは投稿されていません') < 0) return;
      if (t.replace(/\s+/g, '').length > 300) return;
      sec.style.display = 'none';
      sec.setAttribute('data-oo-rev', '1');
    });
  }

  /* ----------------------------------------------------------------
     12) 英語や変な訳の見出しを直し、値段のカンマも入れ直す
  ---------------------------------------------------------------- */
  var WORDS = [
    ['YOU MAY ALSO LIKE', 'こちらもおすすめ'],
    ['FILTER BY', '絞り込み'],
    ['VIEW ALL', 'すべてを見る'],
    ['RECENTLY VIEWED', '最近見た商品'],
    ['REVIEW', 'レビュー'],
    ['OOPS!', 'ページが見つかりません'],
    ['QUANTITY', '数量'],
    ['ACCOUNT', 'マイページ'],
    ['白髪', 'グレー']
  ];

  function fixWords() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue || '';

      // 値段のカンマが抜けることがあるので入れ直す（¥24200 → ¥24,200）
      if (raw.indexOf('¥') >= 0) {
        var fixedYen = raw.replace(/¥(\d{4,})/g, function (all, num) {
          return '¥' + num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        });
        if (fixedYen !== raw) {
          node.nodeValue = fixedYen;
          raw = fixedYen;
        }
      }

      var t = raw.replace(/\s+/g, ' ').trim();
      if (!t || t.length > 32) continue;
      for (var i = 0; i < WORDS.length; i += 1) {
        if (t.toUpperCase() === WORDS[i][0]) {
          node.nodeValue = raw.replace(t, WORDS[i][1]);
          break;
        }
      }
    }
  }

  /* ----------------------------------------------------------------
     16) 売り切れの商品を、帯のうしろへ回す（在庫ありを先に）
  ---------------------------------------------------------------- */
  function soldOutLast(wrap) {
    if (!wrap) return;
    var slides = Array.prototype.slice.call(wrap.children);
    var sold = slides.filter(function (s) {
      return !!s.querySelector('product-card.product-card__sold-out');
    });
    if (!sold.length || sold.length === slides.length) return;

    var tail = slides.slice(slides.length - sold.length);
    var done = tail.every(function (s) { return sold.indexOf(s) >= 0; });
    if (done) return;

    sold.forEach(function (s) {
      wrap.appendChild(s);
    });
  }

  /* ----------------------------------------------------------------
     15) トップの商品の枠の形を整える（2026-10-10 会長）
         NEW ARRIVAL…2段 / RANKING…1段 / COLOR…2段 / ALL ITEM…1段
         段の数を変えたいときは BAND_ROWS の数字を直すだけ。
         2段のときは枠に高さを入れないと縦に伸びるので、fitRowsHeight で計算して入れる。
  ---------------------------------------------------------------- */
  var OO_GAP = 16;

  var BAND_ROWS = {
    'NEW ARRIVAL': 2,
    'RANKING': 1,
    'COLOR': 2,
    'ALL ITEM': 1
  };

  function fitRowsHeight(sl) {
    if (!sl || !sl.getAttribute('data-oo-rows')) return;
    var slides = sl.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    var tall = 0;
    Array.prototype.slice.call(slides).forEach(function (s) {
      var card = s.firstElementChild;
      if (!card) return;
      var h = card.scrollHeight || card.getBoundingClientRect().height;
      if (h > tall) tall = h;
    });
    if (!tall) return;

    var want = Math.ceil(tall * 2 + OO_GAP);
    var now = parseInt(sl.style.height, 10) || 0;
    if (Math.abs(want - now) < 6) return;

    sl.style.height = want + 'px';
    if (sl.swiper) {
      try {
        sl.swiper.update();
      } catch (err) {
        /* 作り直しに失敗しても、商品は出ている */
      }
    }
  }

  function setupBands() {
    if (document.body.className.indexOf('template--index') < 0) return;
    if (!window.Swiper) return;
    var main = document.getElementById('MainContent');
    if (!main) return;

    main.querySelectorAll('.swiper').forEach(function (sl) {
      if (!sl.querySelector('product-card')) return;
      soldOutLast(sl.querySelector('.swiper-wrapper'));

      if (sl.getAttribute('data-oo-band')) {
        fitRowsHeight(sl);
        return;
      }
      if (!sl.swiper) return;

      var sec = sl.closest('.shopify-section');
      var rows = (sec && BAND_ROWS[bandName(sec)]) || 1;

      var opt = {};
      try {
        opt = JSON.parse(sl.getAttribute('data-swiper-options')) || {};
      } catch (err) {
        opt = {};
      }

      try {
        sl.swiper.destroy(true, true);
      } catch (err) {
        return;
      }
      sl.setAttribute('data-oo-band', '1');
      sl.classList.add('oo-band');

      var grid = null;
      if (rows > 1) {
        grid = { rows: rows, fill: 'column' };
        sl.setAttribute('data-oo-rows', '1');
        sl.classList.add('oo-rows');
        sl.style.height = '560px';
      } else {
        sl.style.height = '';
      }

      var conf = {
        a11y: false,
        threshold: 3,
        resistanceRatio: 0.72,
        slidesPerView: opt.slidesPerViewMobile || opt.slidesPerView || 2.4,
        spaceBetween: OO_GAP,
        autoplay: opt.autoplay || false,
        navigation: opt.navigation || false,
        breakpoints: {
          750: { slidesPerView: opt.slidesPerViewTablet || 3, spaceBetween: OO_GAP },
          1100: { slidesPerView: opt.slidesPerViewDesktop || 4, spaceBetween: OO_GAP }
        }
      };
      if (grid) {
        conf.grid = grid;
        conf.breakpoints[750].grid = grid;
        conf.breakpoints[1100].grid = grid;
      }

      try {
        new window.Swiper(sl, conf);
      } catch (err) {
        /* 作り直せなかったときは、横に流れないままになるが、商品は出ている */
      }

      fitRowsHeight(sl);
    });
  }

  /* ----------------------------------------------------------------
     17) トップの帯の順番を決める（2026-10-10 会長／2026-10-21 BBIMP を追加）
         ブランドの帯のすぐ下から BBIMP → NEW ARRIVAL → RANKING → COLOR → ALL ITEM
  ---------------------------------------------------------------- */
  var BAND_ORDER = ['NEW ARRIVAL', 'RANKING', 'COLOR', 'ALL ITEM'];

  /* OO(2026-10-21 会長の指示)
     「BBIMP 秋冬のおすすめ」を BRAND のすぐ下（いちばん上の商品の枠）に置きます。
     この枠は出ないことがあります（4点すべて売り切れたときなど）。
     そのときに上の4つの並べ替えまで止まらないよう、別の一覧にして
     「あれば先頭に足す」形にしています。 */
  var BAND_FIRST = ['BBIMP'];

  function bandName(sec) {
    if (sec.id === 'oo-entry') return 'COLOR';
    if (sec.id === 'oo-bbimp') return 'BBIMP';
    var h = sec.querySelector('h1, h2, h3');
    if (!h) return '';
    return (h.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function orderHomeBands() {
    if (document.body.className.indexOf('template--index') < 0) return;
    var main = document.getElementById('MainContent');
    if (!main) return;

    var kids = Array.prototype.slice.call(main.children);
    var found = {};
    var brand = null;

    kids.forEach(function (sec) {
      var name = bandName(sec);
      if (!name) return;
      if (name === 'BRAND' && !brand) brand = sec;
      if (BAND_ORDER.indexOf(name) >= 0 && !found[name]) found[name] = sec;
      if (BAND_FIRST.indexOf(name) >= 0 && !found[name]) found[name] = sec;
    });

    var list = BAND_ORDER.map(function (k) { return found[k]; });
    if (list.indexOf(undefined) >= 0) return;

    if (!brand) {
      var firstI = kids.length;
      var firstSec = null;
      list.forEach(function (s) {
        var i = kids.indexOf(s);
        if (i >= 0 && i < firstI) {
          firstI = i;
          firstSec = s;
        }
      });
      if (!firstSec) return;
      brand = firstSec.previousElementSibling;
      if (!brand) return;
    }

    /* OO(2026-10-21) 出ていれば BBIMP の枠をいちばん前に足す。
       （BRAND が見つからないときの上の予備処理には混ぜません。
         BBIMP は main のいちばん上に置かれるので、そこを起点にすると
         ひとつ上の要素が無く、並べ替え自体が止まってしまうためです） */
    for (var oi = BAND_FIRST.length - 1; oi >= 0; oi -= 1) {
      if (found[BAND_FIRST[oi]]) list.unshift(found[BAND_FIRST[oi]]);
    }

    var cur = brand.nextElementSibling;
    var same = true;
    for (var i = 0; i < list.length; i += 1) {
      if (cur !== list[i]) {
        same = false;
        break;
      }
      cur = cur.nextElementSibling;
    }
    if (same) return;

    var ref = brand;
    list.forEach(function (sec) {
      main.insertBefore(sec, ref.nextElementSibling);
      ref = sec;
    });

    list.forEach(function (sec) {
      sec.querySelectorAll('.oo-rows').forEach(function (sl) {
        fitRowsHeight(sl);
      });
    });
  }

  /* ----------------------------------------------------------------
     18) 検索の打ち込み欄に薄く出る字を分かりやすくする（2026-10-10 会長）
  ---------------------------------------------------------------- */
  var SEARCH_HINT = '商品名・ブランド名で検索';

  function fixSearchPlaceholder() {
    document.querySelectorAll('input[name="q"]').forEach(function (box) {
      if (box.getAttribute('placeholder') === SEARCH_HINT) return;
      box.setAttribute('placeholder', SEARCH_HINT);
    });
  }

  /* ----------------------------------------------------------------
     13) 検索ページの見出しを「「○○」の検索結果」にする
  ---------------------------------------------------------------- */
  function fixSearchTitle() {
    var q = null;
    try {
      q = new URL(window.location.href).searchParams.get('q');
    } catch (err) {
      return;
    }
    if (!q) return;
    document.querySelectorAll('h1, h2').forEach(function (h) {
      var t = (h.textContent || '').replace(/\s+/g, ' ').trim();
      if (t.indexOf('の検索結果') < 0) return;
      if (t.indexOf('「') === 0) return;
      h.textContent = '「' + q + '」の検索結果';
    });
  }

  /* ----------------------------------------------------------------
     19) 一覧ページで「売り切れ」をページの後ろへ回す（2026-10-10）
         ※ できるのは「いま出ている1ページの中で」だけです。
           2ページ目以降と入れ替えることはできません
           （どの商品を何ページ目に出すかはお店の側で決まっていて、
           　ブラウザからは変えられないため）。
  ---------------------------------------------------------------- */
  function soldOutInList() {
    var cls = document.body.className;
    if (cls.indexOf('template--collection') < 0 && cls.indexOf('template--search') < 0) return;

    var first = document.querySelector('#MainContent product-card');
    if (!first) return;
    var item = first.closest('li, .grid__item, .collection__item') || first.parentElement;
    if (!item || !item.parentElement) return;
    soldOutLast(item.parentElement);
  }

  /* ----------------------------------------------------------------
     21) 検索の候補に「417」とだけ出るのを隠す（2026-10-10 会長のご指摘）

         お店の側（Shopify）の /search/suggest が 417 というエラーを返していて、
         テーマがその数字をそのまま画面に出していました。
         エラーの元はテーマでは直せない（お店の設定側）ので、
         ここでは「数字だけの候補」が出たら枠ごと隠します。
         根本から直すなら、テーマのカスタマイズの「検索の候補（予測検索）」をオフにします。
  ---------------------------------------------------------------- */
  function hideBadSuggest() {
    document.querySelectorAll('predictive-search, .predictive-search, [class*="predictive"]').forEach(function (el) {
      var t = (el.innerText || '').replace(/\s+/g, '');
      if (!t) return;
      if (t.length <= 16 && /\d{3}/.test(t) && !/[぀-ヿ一-鿿]{2,}/.test(t.replace(/クリア/g, ''))) {
        el.style.display = 'none';
        return;
      }
      el.style.display = '';
    });
  }

  /* ----------------------------------------------------------------
     22) 一覧ページの並び替えから「関連性が最も高い」を外す（2026-10-10 会長）
         検索したときの言葉がないので、一覧では意味がありません。
         いま選ばれているときは、画面が飛ぶので外しません。
  ---------------------------------------------------------------- */
  function fixSortOptions() {
    if (document.body.className.indexOf('template--collection') < 0) return;
    document.querySelectorAll('select[name="sort_by"] option, #SortBy option').forEach(function (o) {
      var t = (o.textContent || '').replace(/\s+/g, '');
      var isRel = (o.value || '') === 'relevance' || t.indexOf('関連性') >= 0;
      if (!isRel || o.selected) return;
      if (o.parentNode) o.parentNode.removeChild(o);
    });
  }

  /* ----------------------------------------------------------------
     20) 絞り込んだあと、中身が描き直されても直しが効くようにする（2026-10-10）

         絞り込みは、ページを読み直さずに商品の並びだけ入れ替わります。
         これまでの直し（値段のカンマ・件数・売り切れの並び・貼り付くボタン）は
         読み込み直後の数秒しか動いていなかったので、絞り込んだあとは効いていませんでした。

         ここでは「main の中身が変わったら、もう一度ぜんぶやり直す」ようにします。
         ・自分が書き替えたことで何度も呼ばれないよう、処理中は見張りを休ませます
         ・こまかい変化でいちいち動かないよう、0.25秒まとめてから動きます
  ---------------------------------------------------------------- */
  function afterChange() {
    if (typeof window.ooFixShowing === 'function') {
      try {
        window.ooFixShowing();
      } catch (err) {
        /* 件数が直らなくても、ほかの直しは進める */
      }
    }
    soldOutInList();
    stickyFacetButtons();
    fixWords();
    fixSearchPlaceholder();
    hideBadSuggest();
    fixSortOptions();
  }

  function watchChanges() {
    if (window.__ooWatching) return;
    var main = document.getElementById('MainContent');
    if (!main || !window.MutationObserver) return;
    window.__ooWatching = true;

    var timer = null;
    var busy = false;

    var mo = new MutationObserver(function () {
      if (busy) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        busy = true;
        try {
          afterChange();
        } catch (err) {
          /* 一度うまくいかなくても、次の変化でまたためす */
        }
        setTimeout(function () { busy = false; }, 120);
      }, 250);
    });

    mo.observe(main, { childList: true, subtree: true });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function runAll() {
    placeEntry();
    initEntryColors();
    hideDupHomeSections();
    moveRanking();
    hideEmptyMenuItem();
    placeStyling();
    moveStylingSections();
    fixRankingLink();
    leeepFew();
    stickyFacetButtons();
    hideEmptyReviewSection();
    hideEmptyRecommend();
    orderHomeBands();
    setupBands();
    soldOutInList();
    fixWords();
    fixSearchTitle();
    fixSearchPlaceholder();
    hideBadSuggest();
    fixSortOptions();
    watchChanges();
  }

  ready(function () {
    runAll();

    var tries = 0;
    var timer = setInterval(function () {
      runAll();
      tries += 1;
      if (tries >= 10) clearInterval(timer);
    }, 500);

    // Leeep（インスタの写真）はあとから読み込まれるので、長めに様子を見る
    var late = 0;
    var lateTimer = setInterval(function () {
      moveStylingSections();
      leeepFew();
      stickyFacetButtons();
      hideEmptyReviewSection();
      hideEmptyRecommend();
      hideDupHomeSections();
      orderHomeBands();
      setupBands();
      fixWords();
      fixSearchPlaceholder();
      hideBadSuggest();
      late += 1;
      if (late >= 20) clearInterval(lateTimer);
    }, 1000);

    // 画面の幅が変わったときも、高さをはかり直す
    window.addEventListener('resize', function () {
      document.querySelectorAll('.oo-rows').forEach(function (sl) {
        fitRowsHeight(sl);
      });
    });

    // 置き場所が見つからなかったときは、そのままの場所で出す
    setTimeout(function () {
      var box = document.getElementById('oo-entry');
      if (box) box.classList.add('is-placed');
      var box2 = document.getElementById('oo-styling');
      if (box2) box2.classList.add('is-placed');
    }, 2500);
  });
})();
